module.exports = __webpack_public_path__ + "img/99.f02f274e.svg";